export default "assets/images/icons/dotted-line-c144af7d.svg";